"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CalendarHolidaysResponseScheme = exports.CalendarHolidaysInputScheme = void 0;
var zod_1 = require("zod");
exports.CalendarHolidaysInputScheme = zod_1.z.object({
    durationMonth: zod_1.z.number().optional(),
});
exports.CalendarHolidaysResponseScheme = zod_1.z.array(zod_1.z.object({
    date: zod_1.z.string(),
    dateType: zod_1.z.string(),
    title: zod_1.z.string(),
}));
